// extracted by mini-css-extract-plugin
export default {"contacts":"ContactsList_contacts__2wYHV"};